import {
  ERPSeedless,
  ERPRJL
} from "src/utils/constants";
import { IRoute } from "src/pages/Router/routes";

import CreateDeliveryRoutePage from "./CreateDeliveryRoutePage";
import EditDeliveryRoutePage from "./EditDeliveryRoutePage";

export const DeliveryRoutes: IRoute[] = [
  {
    exact: true,
    title: "Delivery Route",
    menuType: "EMPTY",
    privateRoute: true,
    pageComponent: CreateDeliveryRoutePage,
    path: "/admin/delivery-routes/create",
    roles: [ "admin" ],
    erp: [ ERPSeedless ],
    context: "CREATE_EDIT_DELIVERY_ROUTE"
  },
  {
    exact: true,
    title: "Delivery Route",
    menuType: "EMPTY",
    privateRoute: true,
    pageComponent: EditDeliveryRoutePage,
    path: "/admin/delivery-routes/:deliveryRouteId/edit",
    roles: [ "admin" ],
    erp: [ ERPSeedless ],
    context: "CREATE_EDIT_DELIVERY_ROUTE"
  }
];

export default DeliveryRoutes;
